'use strict';

function changeRangeLabel(filters) {
  const start = filters.dataInicial ?
    moment(filters.dataInicial).format(DATE_FORMAT.toUpperCase()) :
    '';
  const suffix = filters.dataFinal ?
    ` à ${moment(filters.dataFinal).format(DATE_FORMAT.toUpperCase())}` :
    '';
  return `${start}${suffix}`;
}

function isRangeStart(current, start) {
  return !!(start && current.isSame(start));
}

function isRangeEnd(current, end) {
  return !!(end && current.isSame(end));
}

// eslint-disable-next-line max-params
function isInRange(current, start, end, hover) {
  if (start && end) {
    return current.isAfter(start) && current.isBefore(end);
  }
  if (start && hover) {
    const min = moment.min(start, hover);
    const max = moment.max(start, hover);
    return current.isAfter(min) && current.isBefore(max);
  }
  return false;
}

// eslint-disable-next-line max-params
function getDayClass(date, mode, filters, hover) {
  if (mode !== 'day') {
    return '';
  }
  const current = moment(date).startOf('day');
  const start = filters.dataInicial ?
    moment(filters.dataInicial).startOf('day') :
    null;
  const end = filters.dataFinal ?
    moment(filters.dataFinal).startOf('day') :
    null;
  const classes = [];
  if (isRangeStart(current, start)) {
    classes.push('range-start');
  }
  if (isRangeEnd(current, end)) {
    classes.push('range-end');
  }
  if (isInRange(current, start, end, hover)) {
    classes.push('in-range');
  }
  return classes.join(' ');
}

function applyDateSelection(date, filters) {
  const hasStart = !!filters.dataInicial;
  const hasEnd = !!filters.dataFinal;
  if (!hasStart || (hasStart && hasEnd)) {
    filters.dataInicial = date;
    filters.dataFinal = null;
    return;
  }
  const start = moment(filters.dataInicial).startOf('day');
  const current = moment(date).startOf('day');
  if (current.isBefore(start)) {
    filters.dataInicial = date;
    filters.dataFinal = null;
  } else {
    filters.dataFinal = date;
  }
}

function isDateDisabled(dateObj, filters) {
  if (dateObj.mode !== 'day' || !filters.dataInicial || filters.dataFinal) {
    return false;
  }
  const current = moment(dateObj.date).startOf('day');
  const start = moment(filters.dataInicial).startOf('day');
  return current.isBefore(start);
}

function makePickerOptions(filters, getHoverDate) {
  return {
    showWeeks: false,
    customClass: function(obj) {
      return getDayClass(obj.date, obj.mode, filters, getHoverDate());
    },
    dateDisabled: function(obj) {
      return isDateDisabled(obj, filters);
    }
  };
}

// eslint-disable-next-line max-params
function PeriodSelectionModalCtrl($scope, $uibModalInstance, filters, period) {
  $scope.filters = filters;
  $scope.period = period;
  $scope.hoverDate = null;
  $scope.pickerModel = null;
  $scope.setHoverDate = function(date) {
    $scope.hoverDate = moment(date).startOf('day');
  };
  $scope.clearHoverDate = function() {
    $scope.hoverDate = null;
  };
  $scope.onDateSelected = function() {
    if (!$scope.pickerModel) {
      return;
    }
    applyDateSelection($scope.pickerModel, filters);
    $scope.pickerModel = null;
  };
  $scope.closePeriodSelection = function() {
    $scope.period.periodo = changeRangeLabel(filters);
    $uibModalInstance.close();
  };
  $scope.datePickerOptions = makePickerOptions(filters, function() {
    return $scope.hoverDate;
  });
}

angular
  .module('webAgro1App')
  .controller('PeriodSelectionModalCtrl', PeriodSelectionModalCtrl);
